var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9794 16.1183C13.9794 16.3548 13.8098 16.5576 13.6402 16.5576H13.5045C13.3009 16.5576 13.1652 16.3548 13.1652 16.1183V14.5977L12.2153 14.6315C12.1474 14.6315 12.0795 14.5639 12.0795 14.4625C12.0795 14.3612 12.1474 14.2936 12.2153 14.2936L13.1991 14.2598V13.9895C13.1991 13.7529 13.3688 13.5502 13.5384 13.5502H13.6741C13.8777 13.5502 14.0134 13.7529 14.0134 13.9895V16.1183H13.9794ZM23.4772 28.8912V2.39916H15.267V0L8.10845 2.39916H7.90489V28.8574H0V29.6346H8.24416L15.233 32V3.17635H22.6969V29.6346H30.5V28.8574H23.4772V28.8912Z",
    fill: "#F22B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableRoom);
export default __webpack_public_path__ + "static/media/availableRoom.0e2e9f5df70a4bcb6c6cd9cad1070481.svg";
export { ForwardRef as ReactComponent };